'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

var _palette = require('../foundational-styles/palette');

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTooltipProps = function getTooltipProps(appearance) {
  switch (appearance) {
    case 'card':
      return {
        backgroundColor: 'white',
        elevation: 3
      };
    case 'default':
    default:
      return {
        color: 'white',
        backgroundColor: (0, _tinycolor2.default)(_palette2.default.neutral.base).setAlpha(0.95).toString()
      };
  }
};

exports.default = getTooltipProps;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvZ2V0VG9vbHRpcFByb3BzLmpzIl0sIm5hbWVzIjpbImdldFRvb2x0aXBQcm9wcyIsImFwcGVhcmFuY2UiLCJiYWNrZ3JvdW5kQ29sb3IiLCJlbGV2YXRpb24iLCJjb2xvciIsInBhbGV0dGUiLCJuZXV0cmFsIiwiYmFzZSIsInNldEFscGhhIiwidG9TdHJpbmciXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLGtCQUFrQixTQUFsQkEsZUFBa0IsYUFBYztBQUNwQyxVQUFRQyxVQUFSO0FBQ0UsU0FBSyxNQUFMO0FBQ0UsYUFBTztBQUNMQyx5QkFBaUIsT0FEWjtBQUVMQyxtQkFBVztBQUZOLE9BQVA7QUFJRixTQUFLLFNBQUw7QUFDQTtBQUNFLGFBQU87QUFDTEMsZUFBTyxPQURGO0FBRUxGLHlCQUFpQix5QkFBVUcsa0JBQVFDLE9BQVIsQ0FBZ0JDLElBQTFCLEVBQ2RDLFFBRGMsQ0FDTCxJQURLLEVBRWRDLFFBRmM7QUFGWixPQUFQO0FBUko7QUFlRCxDQWhCRDs7a0JBa0JlVCxlIiwiZmlsZSI6ImdldFRvb2x0aXBQcm9wcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0aW55Y29sb3IgZnJvbSAndGlueWNvbG9yMidcbmltcG9ydCBwYWxldHRlIGZyb20gJy4uL2ZvdW5kYXRpb25hbC1zdHlsZXMvcGFsZXR0ZSdcblxuY29uc3QgZ2V0VG9vbHRpcFByb3BzID0gYXBwZWFyYW5jZSA9PiB7XG4gIHN3aXRjaCAoYXBwZWFyYW5jZSkge1xuICAgIGNhc2UgJ2NhcmQnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiAnd2hpdGUnLFxuICAgICAgICBlbGV2YXRpb246IDNcbiAgICAgIH1cbiAgICBjYXNlICdkZWZhdWx0JzpcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgY29sb3I6ICd3aGl0ZScsXG4gICAgICAgIGJhY2tncm91bmRDb2xvcjogdGlueWNvbG9yKHBhbGV0dGUubmV1dHJhbC5iYXNlKVxuICAgICAgICAgIC5zZXRBbHBoYSgwLjk1KVxuICAgICAgICAgIC50b1N0cmluZygpXG4gICAgICB9XG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgZ2V0VG9vbHRpcFByb3BzXG4iXX0=